import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "008_remove_invoice_item_header_fk",
  version: "1.4.4",
  ignoreErrors: [
    "no such table: accounting_invoice_items",
  ],
  sql: `
DROP TABLE IF EXISTS \`accounting_invoice_items_new\`;

CREATE TABLE \`accounting_invoice_items_new\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`invoice_id\` text NOT NULL,
  \`item_id\` text,
  \`description\` text,
  \`qty\` real NOT NULL DEFAULT 1,
  \`rate\` real NOT NULL DEFAULT 0,
  \`amount\` real NOT NULL DEFAULT 0,
  \`account_id\` text,
  \`tax_template_id\` text,
  \`tax_amount\` real NOT NULL DEFAULT 0,
  \`unit_of_measure\` text,
  \`discount_rate\` real DEFAULT 0,
  \`discount_amount\` real DEFAULT 0,
  \`wht_rate\` real DEFAULT 0,
  \`wht_amount\` real DEFAULT 0,
  \`net_amount\` real DEFAULT 0,
  \`line_type\` text,
  \`line_tax_point_date\` text,
  \`line_vat_status\` text,
  \`cost_center_id\` text,
  \`line_reference_module\` text,
  \`line_reference_doctype\` text,
  \`line_reference_id\` text,
  \`sort_order\` integer NOT NULL DEFAULT 0,
  \`created_at\` text NOT NULL,
  FOREIGN KEY (\`item_id\`) REFERENCES \`accounting_items\`(\`id\`) ON UPDATE no action ON DELETE no action,
  FOREIGN KEY (\`account_id\`) REFERENCES \`accounting_accounts\`(\`id\`) ON UPDATE no action ON DELETE no action,
  FOREIGN KEY (\`tax_template_id\`) REFERENCES \`accounting_tax_templates\`(\`id\`) ON UPDATE no action ON DELETE no action
);

INSERT INTO \`accounting_invoice_items_new\` (
  \`id\`,
  \`invoice_id\`,
  \`item_id\`,
  \`description\`,
  \`qty\`,
  \`rate\`,
  \`amount\`,
  \`account_id\`,
  \`tax_template_id\`,
  \`tax_amount\`,
  \`unit_of_measure\`,
  \`discount_rate\`,
  \`discount_amount\`,
  \`wht_rate\`,
  \`wht_amount\`,
  \`net_amount\`,
  \`line_type\`,
  \`line_tax_point_date\`,
  \`line_vat_status\`,
  \`cost_center_id\`,
  \`line_reference_module\`,
  \`line_reference_doctype\`,
  \`line_reference_id\`,
  \`sort_order\`,
  \`created_at\`
)
SELECT
  \`id\`,
  \`invoice_id\`,
  \`item_id\`,
  \`description\`,
  \`qty\`,
  \`rate\`,
  \`amount\`,
  \`account_id\`,
  \`tax_template_id\`,
  \`tax_amount\`,
  \`unit_of_measure\`,
  \`discount_rate\`,
  \`discount_amount\`,
  \`wht_rate\`,
  \`wht_amount\`,
  \`net_amount\`,
  \`line_type\`,
  \`line_tax_point_date\`,
  \`line_vat_status\`,
  \`cost_center_id\`,
  \`line_reference_module\`,
  \`line_reference_doctype\`,
  \`line_reference_id\`,
  \`sort_order\`,
  \`created_at\`
FROM \`accounting_invoice_items\`;

DROP TABLE \`accounting_invoice_items\`;

ALTER TABLE \`accounting_invoice_items_new\`
RENAME TO \`accounting_invoice_items\`;

CREATE INDEX IF NOT EXISTS \`inv_item_line_ref_idx\`
  ON \`accounting_invoice_items\` (\`line_reference_module\`, \`line_reference_id\`);
  `.trim(),
};
